import './styles.css';
import React from 'react';
import { Slot } from 'expo-router';
import { StatusBar } from 'expo-status-bar';
import { MD3LightTheme as PaperDefaultTheme, PaperProvider } from 'react-native-paper';
import { I18nManager, Platform } from 'react-native';
import axios from 'axios';
import { useFonts } from 'expo-font';
import * as Notifications from 'expo-notifications';
import * as ScreenCapture from 'expo-screen-capture';
import { SessionProvider } from '../ctx/ctx';
import MainContextProvider from '../contexts/MainContext';
import CustomSnackbar from '../components/CustomSnackbar/CustomSnackbar';
import { useNotificationObserver } from '../helpers/useNotificationObserver';
import { SafeAreaView, SafeAreaProvider } from 'react-native-safe-area-context';
// import { useLocationTaskManager } from '../helpers/useLocationTaskManager';

if (Platform.OS !== 'web') {
  Notifications.setNotificationHandler({
    handleNotification: async () => ({
      shouldShowAlert: true,
      shouldPlaySound: true,
      shouldSetBadge: true,
    }),
  });
}

export default function Root() {
  if (Platform.OS !== 'web') {
    useNotificationObserver();
    // useLocationTaskManager();
  }
  axios.defaults.baseURL = `https://40lsoton.ir/api`;
  axios.defaults.headers.common['Cache-Control'] = 'no-cache';
  axios.defaults.headers.common['Pragma'] = 'no-cache';
  axios.defaults.headers.common['Expires'] = '0';

  React.useEffect(() => {
    async function forceToRtl(){
      I18nManager.forceRTL(true);
      I18nManager.allowRTL(true);
    }
    forceToRtl();
  }, [])

  React.useEffect(() => {
    async function disableScreenShot() {
      await ScreenCapture.preventScreenCaptureAsync();
    }
    if (Platform.OS !== 'web') {
      disableScreenShot();
    }
  }, [])
  
  const [fontsLoaded] = useFonts({
    'IRANSans_Black': require('../assets/fonts/IRANSans_Black.ttf'),
    'IRANSans_Bold': require('../assets/fonts/IRANSans_Bold.ttf'),
    'IRANSans_Medium': require('../assets/fonts/IRANSans_Medium.ttf'),
    'IRANSans_Light': require('../assets/fonts/IRANSans_Light.ttf'),
    'IRANSans_UltraLight': require('../assets/fonts/IRANSans_UltraLight.ttf'),
    'IRANSans': require('../assets/fonts/IRANSans.ttf'),
  });

  const theme = {
    ...PaperDefaultTheme,
    colors: {
      ...PaperDefaultTheme.colors,
      error: '#d61600',
      primary: '#f9e013',
      secondary: 'yellow',
      outline: '#c6c5c4',
      background: '#fcfcfd',
      scrim: 'yellow',
      surface: 'transparent',
    },
    fonts: {
      ...PaperDefaultTheme.fonts,
      bodyLarge:{
        "fontFamily":"IRANSans",
        "fontSize":16,
        "fontWeight":"400",
        "letterSpacing":0.15,
        "lineHeight":24
      },
      bodyMedium:{
        "fontFamily":"IRANSans",
        "fontSize":14,
        "fontWeight":"400",
        "letterSpacing":0.25,
        "lineHeight":20
      },
      bodySmall:{
        "fontFamily":"IRANSans",
        "fontSize":12,
        "fontWeight":"400",
        "letterSpacing":0.4,
        "lineHeight":16
      },
      default: {
        "fontFamily":"IRANSans",
        "fontWeight":"400",
        "letterSpacing":0
      },
      displayLarge:{
        "fontFamily":"IRANSans",
        "fontSize":57,
        "fontWeight":"400",
        "letterSpacing":0,
        "lineHeight":64
      },
      displayMedium:{
        "fontFamily":"IRANSans",
        "fontSize":45,
        "fontWeight":"400",
        "letterSpacing":0,
        "lineHeight":52
      },
      displaySmall:{
        "fontFamily":"IRANSans",
        "fontSize":36,
        "fontWeight":"400",
        "letterSpacing":0,
        "lineHeight":44
      },
      headlineLarge:{
        "fontFamily":"IRANSans",
        "fontSize":32,
        "fontWeight":"400",
        "letterSpacing":0,
        "lineHeight":40
      },
      headlineMedium:{
        "fontFamily":"IRANSans",
        "fontSize":28,
        "fontWeight":"400",
        "letterSpacing":0,
        "lineHeight":36
      },
      headlineSmall:{
        "fontFamily":"IRANSans",
        "fontSize":24,
        "fontWeight":"400",
        "letterSpacing":0,
        "lineHeight":32
      },
      labelLarge: {
        "fontFamily":"IRANSans",
        "fontSize":14,
        "fontWeight":"500",
        "letterSpacing":0.1,
        "lineHeight":20
      },
      labelMedium: {
        "fontFamily":"IRANSans",
        "fontSize":12,
        "fontWeight":"500",
        "letterSpacing":0.5,
        "lineHeight":16
      },
      labelSmall: {
        "fontFamily":"IRANSans",
        "fontSize":11,
        "fontWeight":"500",
        "letterSpacing":0.5,
        "lineHeight":16
      },
      titleLarge:{
        "fontFamily":"IRANSans",
        "fontSize":22,
        "fontWeight":"400",
        "letterSpacing":0,
        "lineHeight":28
      },
      titleMedium:{
        "fontFamily":"IRANSans",
        "fontSize":16,
        "fontWeight":"500",
        "letterSpacing":0.15,
        "lineHeight":24
      },
      titleSmall:{
        "fontFamily":"IRANSans",
        "fontSize":14,
        "fontWeight":"500",
        "letterSpacing":0.1,
        "lineHeight":20
      }
    },
  };

  if (!fontsLoaded) {
    return null;
  }

  return (
    <SafeAreaProvider>
      <SafeAreaView style={{ flex: 1, direction: 'rtl' }} edges={['top', 'bottom']}>
        <PaperProvider theme={theme}>
          <SessionProvider>
            <MainContextProvider>
              <StatusBar style="auto" translucent={false} />
              <Slot />
              <CustomSnackbar />
            </MainContextProvider>
          </SessionProvider>
        </PaperProvider>
      </SafeAreaView>
    </SafeAreaProvider>
  );
}
